export default function(data) {
  return data.filter(d => d.sets.length > 1)
}



// WEBPACK FOOTER //
// ./src/actions/products/filterOnlySets.js